import React from 'react';
import dayjs from 'dayjs';
import { OlympicFinishIcon, OlympicGroundIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

import { IOlympicList } from '../models';
import { olympicConst } from '..';

interface IProps {
  olympic?: IOlympicList;
}

const OlympicStatistics: React.FC<IProps> = ({ olympic }) => {
  const t = useTranslations();
  const { asPath } = useRouter();

  return (
    <>
      <div className="rounded-xl bg-white p-2 sm:p-4">
        <h1 className="text-lg font-extrabold uppercase text-gray-800 sm:text-2xl">
          {t('turnir_statistikalari')?.toUpperCase()}
        </h1>
        <div className="mt-2 grid grid-cols-4 items-center gap-2 sm:gap-3">
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-600">{t('ishtirokchilar')}</span>
              <span className="text-lg font-bold text-teal-500 sm:text-2xl">
                {olympic?.total_participants?.toLocaleString('ru') || 0}
              </span>
            </div>
          </div>
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-600">{t('variantlar_soni')}</span>
              <span className="text-lg font-bold text-purple-500 sm:text-2xl">{olympic?.course_count || 0}</span>
            </div>
          </div>
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-600">{t('ortacha_natija')}</span>
              <span className="text-lg font-bold text-green-500 sm:text-2xl">{olympic?.average_percent || 0}%</span>
            </div>
          </div>
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-600">{t('maksimal_natija')}</span>
              <span className="text-lg font-bold text-orange-500 sm:text-2xl">{olympic?.max_percent || 0}%</span>
            </div>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden rounded-xl bg-white p-2 sm:p-3">
        <div className="flex items-center justify-between">
          <div>
            <div className="z-2 absolute -left-1 bottom-0">
              <OlympicGroundIcon />
            </div>
            <div className="absolute bottom-2.5 z-0">
              <OlympicFinishIcon />
            </div>
            {olympic?.end_time ? (
              <p className="ml-8 flex items-center gap-1 text-xs text-gray-800">
                <span className="hidden sm:block">{t('ushbu_test_imtihoni')} </span>
                <strong> {dayjs.unix(olympic?.end_time).format(globalConst.dateFormats.LOCAL_DATE_TIME)}</strong>{' '}
                <span className="hidden sm:block">{t('sanada')}</span>
                {olympic?.status === olympicConst.OlympicStatuses.ACTIVE ? t('yakunlanadi') : t('yakunlangan')}
              </p>
            ) : null}
          </div>
          <Link
            href={`${asPath}/natijalar`}
            className="rounded-lg !bg-green-50 px-3 py-1 font-medium !text-green-600 sm:px-4 sm:py-1.5"
          >
            {t('natijani_korish')}
          </Link>
        </div>
      </div>
    </>
  );
};

export default OlympicStatistics;
